import type { OneChanceState } from "app/one-chance/oneChanceState";
import {
  INITIAL_STATE,
  OneChanceAction,
  oneChanceReducer,
} from "app/one-chance/oneChanceState";
import useResetableStorage from "app/utils/useResetableStorage";
import { createContext, useCallback, useContext, useReducer } from "react";

export function useOneChanceReducer(storageKey: string) {
  const serializer = (state: OneChanceState): string => JSON.stringify(state);
  const deserializer = (value: string): OneChanceState => JSON.parse(value);

  const [savedState, setSaveState] = useResetableStorage(
    storageKey,
    INITIAL_STATE,
    { raw: false, serializer, deserializer },
  );

  const reducerLocalStorage = useCallback(
    (state: OneChanceState, action: OneChanceAction) => {
      const newState = oneChanceReducer(state, action);
      setSaveState(newState);
      return newState;
    },
    [setSaveState],
  );

  return useReducer(reducerLocalStorage, savedState || INITIAL_STATE);
}

export const OneChanceDispatchContext = createContext<
  React.Dispatch<OneChanceAction>
>(() => {});

export function useOneChanceActionDispatch() {
  return useContext(OneChanceDispatchContext);
}

export const OneChanceContext = createContext<OneChanceState>(INITIAL_STATE);

export function useOneChanceState() {
  return useContext(OneChanceContext);
}
